export const countryOptions = [
  { label: "🇦🇫: Afghanistan", value: "AF" },
  { label: "🇦🇱: Albania", value: "AL" },
  { label: "🇩🇿: Algeria", value: "DZ" },
  { label: "🇦🇩: Andorra", value: "AD" },
  { label: "🇦🇴: Angola", value: "AO" },
  { label: "🇦🇮: Anguilla", value: "AI" },
  { label: "🇦🇶: Antarctica", value: "AQ" },
  { label: "🇦🇬: Antigua and Barbuda", value: "AG" },
  { label: "🇦🇷: Argentina", value: "AR" },
  { label: "🇦🇲: Armenia", value: "AM" },
  { label: "🇦🇼: Aruba", value: "AW" },
  { label: "🇦🇺: Australia", value: "AU" },
  { label: "🇦🇹: Austria", value: "AT" },
  { label: "🇦🇿: Azerbaijan", value: "AZ" },
  { label: "🇧🇸: Bahamas", value: "BS" },
  { label: "🇧🇭: Bahrain", value: "BH" },
  { label: "🇧🇩: Bangladesh", value: "BD" },
  { label: "🇧🇧: Barbados", value: "BB" },
  { label: "🇧🇾: Belarus", value: "BY" },
  { label: "🇧🇪: Belgium", value: "BE" },
  { label: "🇧🇿: Belize", value: "BZ" },
  { label: "🇧🇯: Benin", value: "BJ" },
  { label: "🇧🇲: Bermuda", value: "BM" },
  { label: "🇧🇹: Bhutan", value: "BT" },
  { label: "🇧🇴: Bolivia (Plurinational State of)", value: "BO" },
  { label: "🇧🇦: Bosnia and Herzegovina", value: "BA" },
  { label: "🇧🇼: Botswana", value: "BW" },
  { label: "🇧🇷: Brazil", value: "BR" },
  { label: "🇮🇴: British Indian Ocean Territory", value: "IO" },
  { label: "🇻🇬: Virgin Islands (British)", value: "VG" },
  { label: "🇧🇳: Brunei Darussalam", value: "BN" },
  { label: "🇧🇬: Bulgaria", value: "BG" },
  { label: "🇧🇫: Burkina Faso", value: "BF" },
  { label: "🇧🇮: Burundi", value: "BI" },
  { label: "🇰🇭: Cambodia", value: "KH" },
  { label: "🇨🇲: Cameroon", value: "CM" },
  { label: "🇨🇦: Canada", value: "CA" },
  { label: "🇨🇻: Cape Verde", value: "CV" },
  { label: "🇰🇾: Cayman Islands", value: "KY" },
  { label: "🇨🇫: Central African Republic", value: "CF" },
  { label: "🇹🇩: Chad", value: "TD" },
  { label: "🇨🇱: Chile", value: "CL" },
  { label: "🇨🇳: China", value: "CN" },
  { label: "🇨🇽: Christmas Island", value: "CX" },
  { label: "🇨🇨: Cocos (Keeling) Islands", value: "CC" },
  { label: "🇨🇴: Colombia", value: "CO" },
  { label: "🇰🇲: Comoros", value: "KM" },
  { label: "🇨🇬: Congo", value: "CG" },
  { label: "🇨🇩: Congo (Democratic Republic of the)", value: "CD" },
  { label: "🇨🇰: Cook Islands", value: "CK" },
  { label: "🇨🇷: Costa Rica", value: "CR" },
  { label: "🇭🇷: Croatia", value: "HR" },
  { label: "🇨🇺: Cuba", value: "CU" },
  { label: "🇨🇼: Curaçao", value: "CW" },
  { label: "🇨🇾: Cyprus", value: "CY" },
  { label: "🇨🇿: Czech Republic", value: "CZ" },
  { label: "🇩🇰: Denmark", value: "DK" },
  { label: "🇩🇯: Djibouti", value: "DJ" },
  { label: "🇩🇲: Dominica", value: "DM" },
  { label: "🇩🇴: Dominican Republic", value: "DO" },
  { label: "🇪🇨: Ecuador", value: "EC" },
  { label: "🇪🇬: Egypt", value: "EG" },
  { label: "🇸🇻: El Salvador", value: "SV" },
  { label: "🇬🇶: Equatorial Guinea", value: "GQ" },
  { label: "🇪🇷: Eritrea", value: "ER" },
  { label: "🇪🇪: Estonia", value: "EE" },
  { label: "🇸🇿: Eswatini", value: "SZ" },
  { label: "🇪🇹: Ethiopia", value: "ET" },
  { label: "🇫🇰: Falkland Islands (Malvinas)", value: "FK" },
  { label: "🇫🇴: Faroe Islands", value: "FO" },
  { label: "🇫🇯: Fiji", value: "FJ" },
  { label: "🇫🇮: Finland", value: "FI" },
  { label: "🇫🇷: France", value: "FR" },
  { label: "🇬🇫: French Guiana", value: "GF" },
  { label: "🇵🇫: French Polynesia", value: "PF" },
  { label: "🇹🇫: French Southern Territories", value: "TF" },
  { label: "🇬🇦: Gabon", value: "GA" },
  { label: "🇬🇲: Gambia", value: "GM" },
  { label: "🇬🇪: Georgia", value: "GE" },
  { label: "🇩🇪: Germany", value: "DE" },
  { label: "🇬🇭: Ghana", value: "GH" },
  { label: "🇬🇮: Gibraltar", value: "GI" },
  { label: "🇬🇷: Greece", value: "GR" },
  { label: "🇬🇱: Greenland", value: "GL" },
  { label: "🇬🇩: Grenada", value: "GD" },
  { label: "🇬🇵: Guadeloupe", value: "GP" },
  { label: "🇬🇺: Guam", value: "GU" },
  { label: "🇬🇹: Guatemala", value: "GT" },
  { label: "🇬🇬: Guernsey", value: "GG" },
  { label: "🇬🇳: Guinea", value: "GN" },
  { label: "🇬🇼: Guinea-Bissau", value: "GW" },
  { label: "🇬🇾: Guyana", value: "GY" },
  { label: "🇭🇹: Haiti", value: "HT" },
  { label: "🇭🇳: Honduras", value: "HN" },
  { label: "🇭🇰: Hong Kong", value: "HK" },
  { label: "🇭🇺: Hungary", value: "HU" },
  { label: "🇮🇸: Iceland", value: "IS" },
  { label: "🇮🇳: India", value: "IN" },
  { label: "🇮🇩: Indonesia", value: "ID" },
  { label: "🇮🇷: Iran (Islamic Republic of)", value: "IR" },
  { label: "🇮🇶: Iraq", value: "IQ" },
  { label: "🇮🇪: Ireland", value: "IE" },
  { label: "🇮🇲: Isle of Man", value: "IM" },
  { label: "🇮🇱: Israel", value: "IL" },
  { label: "🇮🇹: Italy", value: "IT" },
  { label: "🇯🇲: Jamaica", value: "JM" },
  { label: "🇯🇵: Japan", value: "JP" },
  { label: "🇯🇪: Jersey", value: "JE" },
  { label: "🇯🇴: Jordan", value: "JO" },
  { label: "🇰🇿: Kazakhstan", value: "KZ" },
  { label: "🇰🇪: Kenya", value: "KE" },
  { label: "🇰🇮: Kiribati", value: "KI" },
  { label: "🇰🇵: Korea (Democratic People's Republic of)", value: "KP" },
  { label: "🇰🇷: Korea, Republic of", value: "KR" },
  { label: "🇽🇰: Kosovo", value: "XK" },
  { label: "🇰🇼: Kuwait", value: "KW" },
  { label: "🇰🇬: Kyrgyzstan", value: "KG" },
  { label: "🇱🇦: Lao People's Democratic Republic", value: "LA" },
  { label: "🇱🇻: Latvia", value: "LV" },
  { label: "🇱🇧: Lebanon", value: "LB" },
  { label: "🇱🇸: Lesotho", value: "LS" },
  { label: "🇱🇷: Liberia", value: "LR" },
  { label: "🇱🇾: Libya", value: "LY" },
  { label: "🇱🇮: Liechtenstein", value: "LI" },
  { label: "🇱🇹: Lithuania", value: "LT" },
  { label: "🇱🇺: Luxembourg", value: "LU" },
  { label: "🇲🇴: Macao", value: "MO" },
  { label: "🇲🇰: North Macedonia", value: "MK" },
  { label: "🇲🇬: Madagascar", value: "MG" },
  { label: "🇲🇼: Malawi", value: "MW" },
  { label: "🇲🇾: Malaysia", value: "MY" },
  { label: "🇲🇻: Maldives", value: "MV" },
  { label: "🇲🇱: Mali", value: "ML" },
  { label: "🇲🇹: Malta", value: "MT" },
  { label: "🇲🇭: Marshall Islands", value: "MH" },
  { label: "🇲🇶: Martinique", value: "MQ" },
  { label: "🇲🇷: Mauritania", value: "MR" },
  { label: "🇲🇺: Mauritius", value: "MU" },
  { label: "🇾🇹: Mayotte", value: "YT" },
  { label: "🇲🇽: Mexico", value: "MX" },
  { label: "🇫🇲: Micronesia (Federated States of)", value: "FM" },
  { label: "🇲🇩: Moldova, Republic of", value: "MD" },
  { label: "🇲🇨: Monaco", value: "MC" },
  { label: "🇲🇳: Mongolia", value: "MN" },
  { label: "🇲🇪: Montenegro", value: "ME" },
  { label: "🇲🇸: Montserrat", value: "MS" },
  { label: "🇲🇦: Morocco", value: "MA" },
  { label: "🇲🇿: Mozambique", value: "MZ" },
  { label: "🇲🇲: Myanmar", value: "MM" },
  { label: "🇳🇦: Namibia", value: "NA" },
  { label: "🇳🇷: Nauru", value: "NR" },
  { label: "🇳🇵: Nepal", value: "NP" },
  { label: "🇳🇱: Netherlands", value: "NL" },
  { label: "🇳🇨: New Caledonia", value: "NC" },
  { label: "🇳🇿: New Zealand", value: "NZ" },
  { label: "🇳🇮: Nicaragua", value: "NI" },
  { label: "🇳🇪: Niger", value: "NE" },
  { label: "🇳🇬: Nigeria", value: "NG" },
  { label: "🇳🇺: Niue", value: "NU" },
  { label: "🇳🇫: Norfolk Island", value: "NF" },
  { label: "🇲🇵: Northern Mariana Islands", value: "MP" },
  { label: "🇳🇴: Norway", value: "NO" },
  { label: "🇴🇲: Oman", value: "OM" },
  { label: "🇵🇰: Pakistan", value: "PK" },
  { label: "🇵🇼: Palau", value: "PW" },
  { label: "🇵🇸: Palestine, State of", value: "PS" },
  { label: "🇵🇦: Panama", value: "PA" },
  { label: "🇵🇬: Papua New Guinea", value: "PG" },
  { label: "🇵🇾: Paraguay", value: "PY" },
  { label: "🇵🇪: Peru", value: "PE" },
  { label: "🇵🇭: Philippines", value: "PH" },
  { label: "🇵🇳: Pitcairn", value: "PN" },
  { label: "🇵🇱: Poland", value: "PL" },
  { label: "🇵🇹: Portugal", value: "PT" },
  { label: "🇵🇷: Puerto Rico", value: "PR" },
  { label: "🇶🇦: Qatar", value: "QA" },
  { label: "🇷🇪: Réunion", value: "RE" },
  { label: "🇷🇴: Romania", value: "RO" },
  { label: "🇷🇺: Russian Federation", value: "RU" },
  { label: "🇷🇼: Rwanda", value: "RW" },
  { label: "🇧🇱: Saint Barthélemy", value: "BL" },
  { label: "🇸🇭: Saint Helena, Ascension and Tristan da Cunha", value: "SH" },
  { label: "🇰🇳: Saint Kitts and Nevis", value: "KN" },
  { label: "🇱🇨: Saint Lucia", value: "LC" },
  { label: "🇲🇫: Saint Martin (French part)", value: "MF" },
  { label: "🇵🇲: Saint Pierre and Miquelon", value: "PM" },
  { label: "🇻🇨: Saint Vincent and the Grenadines", value: "VC" },
  { label: "🇼🇸: Samoa", value: "WS" },
  { label: "🇸🇲: San Marino", value: "SM" },
  { label: "🇸🇹: Sao Tome and Principe", value: "ST" },
  { label: "🇸🇦: Saudi Arabia", value: "SA" },
  { label: "🇸🇳: Senegal", value: "SN" },
  { label: "🇷🇸: Serbia", value: "RS" },
  { label: "🇸🇨: Seychelles", value: "SC" },
  { label: "🇸🇱: Sierra Leone", value: "SL" },
  { label: "🇸🇬: Singapore", value: "SG" },
  { label: "🇸🇽: Sint Maarten (Dutch part)", value: "SX" },
  { label: "🇸🇰: Slovakia", value: "SK" },
  { label: "🇸🇮: Slovenia", value: "SI" },
  { label: "🇸🇧: Solomon Islands", value: "SB" },
  { label: "🇸🇴: Somalia", value: "SO" },
  { label: "🇿🇦: South Africa", value: "ZA" },
  { label: "🇬🇸: South Georgia and the South Sandwich Islands", value: "GS" },
  { label: "🇸🇸: South Sudan", value: "SS" },
  { label: "🇪🇸: Spain", value: "ES" },
  { label: "🇱🇰: Sri Lanka", value: "LK" },
  { label: "🇸🇩: Sudan", value: "SD" },
  { label: "🇸🇷: Suriname", value: "SR" },
  { label: "🇸🇯: Svalbard and Jan Mayen", value: "SJ" },
  { label: "🇸🇿: Eswatini", value: "SZ" },
  { label: "🇸🇪: Sweden", value: "SE" },
  { label: "🇨🇭: Switzerland", value: "CH" },
  { label: "🇸🇾: Syrian Arab Republic", value: "SY" },
  { label: "🇹🇼: Taiwan, Province of China", value: "TW" },
  { label: "🇹🇯: Tajikistan", value: "TJ" },
  { label: "🇹🇿: Tanzania, United Republic of", value: "TZ" },
  { label: "🇹🇭: Thailand", value: "TH" },
  { label: "🇹🇱: Timor-Leste", value: "TL" },
  { label: "🇹🇬: Togo", value: "TG" },
  { label: "🇹🇰: Tokelau", value: "TK" },
  { label: "🇹🇴: Tonga", value: "TO" },
  { label: "🇹🇹: Trinidad and Tobago", value: "TT" },
  { label: "🇹🇳: Tunisia", value: "TN" },
  { label: "🇹🇷: Turkey", value: "TR" },
  { label: "🇹🇲: Turkmenistan", value: "TM" },
  { label: "🇹🇨: Turks and Caicos Islands", value: "TC" },
  { label: "🇹🇻: Tuvalu", value: "TV" },
  { label: "🇺🇬: Uganda", value: "UG" },
  { label: "🇺🇦: Ukraine", value: "UA" },
  { label: "🇦🇪: United Arab Emirates", value: "AE" },
  { label: "🇬🇧: United Kingdom of Great Britain and Northern Ireland", value: "GB" },
  { label: "🇺🇸: United States of America", value: "US" },
  { label: "🇺🇾: Uruguay", value: "UY" },
  { label: "🇺🇿: Uzbekistan", value: "UZ" },
  { label: "🇻🇺: Vanuatu", value: "VU" },
  { label: "🇻🇦: Holy See", value: "VA" },
  { label: "🇻🇪: Venezuela (Bolivarian Republic of)", value: "VE" },
  { label: "🇻🇳: Viet Nam", value: "VN" },
  { label: "🇻🇬: Virgin Islands (British)", value: "VG" },
  { label: "🇻🇮: Virgin Islands (U.S.)", value: "VI" },
  { label: "🇼🇫: Wallis and Futuna", value: "WF" },
  { label: "🇪🇭: Western Sahara", value: "EH" },
  { label: "🇾🇪: Yemen", value: "YE" },
  { label: "🇿🇲: Zambia", value: "ZM" },
  { label: "🇿🇼: Zimbabwe", value: "ZW" },
];

export const participationOptions = [
  "2CV _ Greens _ NJ ( NY) _ November 2019 _ Job #1855.xlsx",
  "2CV _ Grindr _ Online _ In-Person _ LA _ CHI _ Dec 2023 _ Job #2294.xlsx",
  "7th Sense _ D-Ford Fleet _ Nationwide _ Nov 2021.xlsx",
  "7th Sense _ Electric Vehicles _ NY _ March 2019 _ Job #1767.xlsx",
  "7th Sense _ Infiniti _ May 2023 _ Job #2241.xlsx",
  "7th Sense _ U725 Trucks _ SUVs _ LA _ February 2019 _ Job_.xlsx",
  "7th Sense _ Uber _ LA _ February 2019 _ Job_.xlsx",
  "7th Sense _ Uber _ LA _ NY _ February 2020 _ Job # 1875.xlsx",
  "8TH DAY _ Armani _ LA _ NY _ InterVu _ April 2020 _ Job #1889.xlsx",
  "8TH DAY _ Audemars Piguet _ Project Thea _ Job#.xlsx",
  "8TH DAY _ L_Oreal Luxe Sustainability _ IN PERSON _ Chicago _ May 22 _ Job #.xlsx",
  "8TH DAY _ Paradigm  _ March 22 _ Job #2103.xlsx",
  "8TH DAY _ Viktor _ Rolf _ July 2020 _ Job #1908.xlsx",
  "8TH DAY _ Viktor _ Rolf _ NY_LA _ Feb 2021 _ Job #1982.xlsx",
  "8TH DAY _ YSL _ Nationwide _ November 2020 _ Job #1950.xlsx",
  "8th Day _ Anti-Aging _ LA _ NY _ October 2019 _ Job #1832.xlsx",
  "8th Day _ Bayer Aging _ NY _ April 2020 _ Job 1892.xlsx",
  "8th Day _ Garnier _  NYC _ CHI _ Oct 2020 _ Job 1929.xlsx",
  "8th Day _ Johnnie Walker Above the Blue _ The Who II _ Online _ Nov 2023 _ Job #2286.xlsx",
  "8th Day _ Johnnie Walker Above the Blue _ The Who _ NYC, Miami _ May 2023 _ Job #2233.xlsx",
  "8th Day _ L_Oreal _ NY _ February 2020 _ Job 1871.xlsx",
  "8th Day _ Lux Watches Audemar_s Piguet _ NY _ October 2019 _ Job # 1840.xlsx",
  "8th Day _ YSL _ In-Person NYC _ Sept 2023 _ Job #2264.xlsx",
  "8th Day _ _Creative Curious_ _ NY, LA _ May 2019 _ Job.xlsx",
  "Adam_s Egg _ Heineken Round 1 _ ONLINE _ NYC, CHI _ November 2022 _ Job #2199.xlsx",
  "B12 Strategies _ Tiffany _ LA, CHI _ June 2023 _ Job #2227.xlsx",
  "B12 _ Tiffany_s Smile Watch Exploration _ NY _ CHI _ June 2019 _ Job# 1799.xlsx",
  "Brain Value _ Lip Injections _ June 2021 _ NYC_MIA _ Job #2014.xlsx",
  "Brand Genetics _ Cayman Jack _ Sept 2022 _ Job #2167.xlsx",
  "Brand Genetics _ LA _ February 2019 _ Job #.xlsx",
  "Brand Genetics _ Stella CCI _ Online _ NY, LA _ Chicago _ Sept 2023 _ Job #2269.xlsx",
  "Bryter UK _ Gaming _ In-Person _ NY _ Nov 2023 _ Job #2285.xlsx",
  "Calculated SI _ Chivas _ Feb 22 _ Job #.xlsx",
  "Calculated Strategic Insight _ Glenlivet Stage 2 _ Nationwide _ Online _ January 2024 _ Job #2300.xlsx",
  "Calculated _ Aberlour _ Online _ New York _ January 2023 _ Job #2205 .xlsx",
  "Calculated _ Glenlivet _ NY CHI + Nationwide _ In-Person _ Online _ August 2023 _ Job #2253.xlsx",
  "Canova Research _ Mike_s Hard Lemonade _ LA _ January 2020 _ Job 1867.xlsx",
  "Coherency _ Citi Wealth 2 _ November 2021 _ Job #.xlsx",
  "Coherency _ Citi Wealth 3 _ NY, LA _ Jan 2022 _ Job #.xlsx",
  "Coherency _ Citi Wealth _ April 2021 _ NY _ LA _ Job #2001.xlsx",
  "Coherency _ Citi wealth IV _ NY, CHI, LA, MIA, SF, DC _ October 2022 _ Job #2185.xlsx",
  "Coherency _ Citi win in wealth  _ July 2021 _ Job #.xlsx",
  "Coherency _ Citigold _ NY, LA _ April 2019 _ Job 1774.xlsx",
  "Combo _ Wellness Tracking _ August 2022 _ Job #2155.xlsx",
  "Compound Brands _ 4_1 Whiskey Study _ August 2021 _ Job #.xlsx",
  "Compound Brands _ Aperol _ Nationwide _ May 2021 _ Job # 2018.xlsx",
  "Compound Brands _ Avion Super Premium Tequila _ June 2022 _ Job #2149.xlsx",
  "Compound Brands _ Campari _ NATIONWIDE _ ONLINE _ Aug 2022 _ Job #2160.xlsx",
  "Compound Brands _ Campari _ New York, Los Angeles _ February 2023 _ Job #2206.xlsx",
  "Compound Brands _ Citizen M Hotel _ NYC, BOS, LA, CHI, DC, SEA _ September 2021 _ Job #2056.xlsx",
  "Compound Brands _ Cuervo Golden Margarita _ Online _ February 2023 _ Job #2210.xlsx",
  "Compound Brands _ Espolon Cristalino _ August 2021 _ Job #.xlsx",
  "Compound Brands _ Espolon _ Online _ NY, LA, CHI, MIA _ Nov 2023 _ Job #2292.xlsx",
  "Compound Brands _ Finance of America Reverse (FAR) _ LA _ June 2019.xlsx",
  "Compound Brands _ Flavored Spirits _ NY _ November 2019 _ Job #1847.xlsx",
  "Compound Brands _ Fox B1G+ _ March 22 _ Job #2116.xlsx",
  "Compound Brands _ Fox Sports 2021 _ NY, LA, CHI, FL, TX _ GA _  Job #1993.xlsx",
  "Compound Brands _ Fox Sports CFB Fans _ NATIONWIDE _ October 2022 _ Job #2182.xlsx",
  "Compound Brands _ Fox Sports _ World Cup _ IN-PERSON _ NY _ Nov 2022 _ Job #.xlsx",
  "Compound Brands _ Fusion Cask Innovation _ ONLINE _ NATIONWIDE _ May 22 _ Job #.xlsx",
  "Compound Brands _ Glenlivet Cask Fusion II _ ONLINE _ NATIONWIDE _ July 2022 _ Job #2152.xlsx",
  "Compound Brands _ Gran Centenario Tequila _ Online _ Nationwide _ Dec 2023 _ Job #2296.xlsx",
  "Compound Brands _ Grand Marnier Celeb Endorsement _ Online LA ATL CHI DC _ In-Person NYC _ August 2023 _ Job #2259.xlsx",
  "Compound Brands _ Grand Marnier In Person Tastings _ NY _ LA _ August 2022 _ Job #2163.xlsx",
  "Compound Brands _ Grand Marnier _ Online Panel _ May 2022 _ Job #.xlsx",
  "Compound Brands _ Jameson Bartenders _ NY _ November 2019 Job #1857.xlsx",
  "Compound Brands _ Jameson Caskmates _ NY, LA, CHI _ May 2019 _ Job 1797.xlsx",
  "Compound Brands _ Jameson _ Zoom _ April 2020 _ Job #1896.xlsx",
  "Compound Brands _ Mezcal _ Nationwide _ March 2023 _ Job #2216.xlsx",
  "Compound Brands _ Peloton Corporate Wellness _ Feb 2021_.xlsx",
  "Compound Brands _ Peloton _ Feb 2021 _ Job #1973.xlsx",
  "Compound Brands _ Peloton _ November 2020.xlsx",
  "Compound Brands _ Pernod Ricard _ Mezcaleros _ UK, USA (LA, HOU, AUSTIN, NYC, FL, CHI) _ _ ONLINE _ May 2023 _ Job #2237.xlsx",
  "Compound Brands _ Proximo Tequila Mezcal _ June 2023 _ Job #2239.xlsx",
  "Compound Brands _ Proximo Tequila _ LA, NYC, ATL, DAL_HOU, MIA_FL _ July 2021 _ Job #2031.xlsx",
  "Compound Brands _ RDLF _ CA, TX, NY _ ONLINE _ Sept 2022 _ Job #2176.xlsx",
  "Compound Brands _ RTS Category Exploration _ Nationwide _ Sept 2022 _ Job #2171.xlsx",
  "Compound Brands _ Racetrac _ June 2022 _ Job #2145.xlsx",
  "Compound Brands _ SKYY Vodka _ November 2022 _ NYC, SF, LA, South Jersey, Philadelphia, and Orlando _ Job #2193.xlsx",
  "Compound Brands _ USFL _ In Person _ Boulder, CO _ June 2022 _ Job #2141.xlsx",
  "Copy of Fuse Media Sex Sells _ CHI HOU ATL MIA _ JAN 2022.xlsx",
  "Creatures of Habit _ Instagram _ LA _ August 2019 _ Job.xlsx",
  "Creatures of Habit _ Instagram _ LA _ May 2019 _ Job 1791.xlsx",
  "David Sikorjak _ Fox Sports _ College Football Pregame Show Viewers _ Chicago, Los Angeles _ September 2021 _ Job #2057_.xlsx",
  "Dexterity Consulting _ Caesars AC Refresh _ IN PERSON _ NYC _ November 2022 _ Job#2197.xlsx",
  "Dexterity Consulting _ FOX Sports Skinny Bundle _ In-Person _ LA _ CHI _ Sept 2023 _ Job #2268.xlsx",
  "Dexterity Consulting _ LA Clippers Fans _ IN PERSON _ November 2021 _ Job #2083.xlsx",
  "Dexterity Consulting _ Podcasts and Debate Shows _ Nov Dec 2021 _ Job #.xlsx",
  "Dexterity Consulting _ Teen Sports Fans _ In-Person NY, LA _ May 2023 _ Job #2238.xlsx",
  "Dexterity Consulting _ USFL _ In Person _ NY _ May 2022 _ Job #.xlsx",
  "Dexterity Consulting _ USFL _ NY _ January 2022 _ Job #.xlsx",
  "Dexterity Consulting _ William Hill Sports Bettor _ December 2020.xlsx",
  "Dexterity _ Fox Sports NFL Female Fan Follow Up _ LA _ June 2021.xlsx",
  "Dexterity _ iCasino _ NJ, Michigan, Pennsylvania _ May 2021 _ Job # 2012.xlsx",
  "Egg Strategy _ Knob Creek _ Basil Hayden _ NATIONWIDE _ ONLINE _ May 2023 _ Job #2234.xlsx",
  "Egg Strategy _ L_Occitaine _ NATIONWIDE _ ONLINE _ May 2023 _ Job #2235.xlsx",
  "Egg Strategy _ PEPSICO _ NY _ March 2020 _ Job 1876.xlsx",
  "Episode _ L_Oréal - Mugler _ November 2021 _ LA, NYC, DALLAS, MIAMI.xlsx",
  "Episode _ Peloton _ December 2022 _ In Person - CHI _ Job #2201.xlsx",
  "FCB _ Spotify - B2B _ Feb 22 _ Job #.xlsx",
  "FIREFISH _ Stella Meals, Kona, Michelob Ultra _ Presidente _ October 2020 _ Jobs #.xlsx",
  "FIREFLY - Kantar Millward Brown _ Sapphire _ NYC, CHI _ March 2019 _ Job #1763.xlsx",
  "FOLLOW UP_ Compound Brands _ Jameson Caskmates _ NY, LA, CHI _ May 2019 _ Job 1797.xlsx",
  "FOX Deportes _ LA _ May 2019 _ Job #1785.xlsx",
  "FOX _ Debate Talk Shows _ LA _ September 2019 _ Job #.xlsx",
  "Fahrenheit 212 _ Digestive Health _ July 2019 _ Job #1812.xlsx",
  "Fahrenheit 212 _ Shine _ LA _ March 2019 _ Job 1764.xlsx",
  "Field Cats _ Gen AI _ In-Person NYC _ July 2023 _ Job #2248.xlsx",
  "Fieldcats _ Project Chocolate _ OHL Chicago IN-PERSON _ July 2021.xlsx",
  "Fieldcats _ Sharing Economy _ NY _ February 2020 _ Job 1869.xlsx",
  "Firefish _ AB (Michelob Ultra) _ LA, NY, CHI _ May 2022 _ Job#.xlsx",
  "Firefish _ AB Beer Panel _ ONLINE _ August 2022 _ Job #2166.xlsx",
  "Firefish _ AB _ Nov 2021 _ Job #.xlsx",
  "Firefish _ Agave (Tequila) _ LA _ March 2020 _ Job 1880.xlsx",
  "Firefish _ Axe 2 _ March 2021 _ Job #1990.xlsx",
  "Firefish _ Axe _ Feb 2021.xlsx",
  "Firefish _ Axe _ Nationwide _ November 2021.xlsx",
  "Firefish _ BL Next _ March 2022 _ Job #2114.xlsx",
  "Firefish _ BL Platinum (Energy Drinks) _ NY_NJ_LA_ATL_Detroit_CHI_OH _ July 2021 _ Job #.xlsx",
  "Firefish _ BLS Family Seltzer _ June 2021 _ Nationwide _ Job #2024.xlsx",
  "Firefish _ BLS Innovation _ CA_NY_IL + CO_TX_GA_MO_NJ _ May 2021 _ Job #2016.xlsx",
  "Firefish _ BLS Lab Comms - Seltzer _ March 2021.xlsx",
  "Firefish _ Baileys _ ONLINE _ NATIONWIDE _ October - November 2022 _ Job #2187.xlsx",
  "Firefish _ Beefeater _ NY _ June 2019 _ Job 1805.xlsx",
  "Firefish _ Beer - Total Demand Space _ ONLINE _ NATIONWIDE _ November 2022 _ Job #2188.xlsx",
  "Firefish _ Bodywash _ NATIONWIDE _ ONLINE _ November 2022 _ Job #2195.xlsx",
  "Firefish _ Botanist Gin _ Feb 22 _ Job #.xlsx",
  "Firefish _ Bud Iconic II _ NJ, NY, MA, PA, ATL, MD, DC, MI November 2022 _ Job #2184_.xlsx",
  "Firefish _ Bud Iconic _ Sept 2022 _ Job #2168.xlsx",
  "Firefish _ Bud Light Hard Soda 2 _ October 2021 _ Job #.xlsx",
  "Firefish _ Bud Light Hard Soda _ September 2021 _ Job #.xlsx",
  "Firefish _ Bud Light Peels _ Hard Seltzer _ InterVu _ June 2020.xlsx",
  "Firefish _ Bud Light Seltzer #2 _ Nationwide _ Discuss.io _ October 2020 _ Job 1940.xlsx",
  "Firefish _ Bud Light Seltzer _ CHI _ NY _ April 2020 _ Job#1898.xlsx",
  "Firefish _ Bud Light _ Seltzer _ November 2020 _ Job #1952 _ #1954.xlsx",
  "Firefish _ Bud Occasions _ NY LA CHI _ Aug 2020.xlsx",
  "Firefish _ Bud Super Bowl _ Multi-Market _ Sept 2020.xlsx",
  "Firefish _ Bud light_Bud Light Seltzer _ May 2020 _ #1900.xlsx",
  "Firefish _ Budweiser _ Nationwide _ Jan 2021.xlsx",
  "Firefish _ Campari Ethno_s _ April 22 _ Job #2096.xlsx",
  "Firefish _ Canopy Growth _ Jan 21 _ Job #1974.xlsx",
  "Firefish _ Core+ _ June 2021 _ Nationwide _ Job #2026.xlsx",
  "Firefish _ Craft Seltzer _ July 2020 _ Job# 1907.xlsx",
  "Firefish _ Cutwater _ Jan 22 _ Job #.xlsx",
  "Firefish _ DSC _ ONLINE _ NY, CHI, LA _ Aug 2022 _ Job #2153.xlsx",
  "Firefish _ Demand Space Phase 2 _ Nationwide _ Online _ August 2023 _ Job #2255.xlsx",
  "Firefish _ Diageo - Pop Ups _ Feb 22 _ Job #2108.xlsx",
  "Firefish _ Dollar Shave Club _ Feb 2022 _ National _ Job #2109.xlsx",
  "Firefish _ Dollar Shave Club _ July-August _ Job #.xlsx",
  "Firefish _ Dove Mankinship _ Discuss.io _ July 2020 _ Job #1910.xlsx",
  "Firefish _ Dove Purpose _ Nationwide _ October 2021 _ Job #.xlsx",
  "Firefish _ Dove _ Nationwide _ Feb 2021 _ Job #_.xlsx",
  "Firefish _ Folgers Coffee _ March 2021.xlsx",
  "Firefish _ Golden Road #2 _ Philly, Tampa, Kansas City _ January 21.xlsx",
  "Firefish _ Guinness _ Nov 2021 _ New York, Chicago, Boston _ Job #2077.xlsx",
  "Firefish _ Heineken C-Store _ NY LA MIA _ April 2021.xlsx",
  "Firefish _ JW Mariott Hotels _ NY, LA _ November 2019 _ Job#1848.xlsx",
  "Firefish _ Jager Creative Phase 2 _ Nationwide _ October 2020 _ Job #.xlsx",
  "Firefish _ Jagermeister _ NY LA CHI MIDWEST _ Aug 2020.xlsx",
  "Firefish _ Jägermeister _ NY, CHI _ May 2019 _ Job 1776.xlsx",
  "Firefish _ Jägermesiter Project Harmony _ CHI _ May 2019 _ Job.xlsx",
  "Firefish _ Jif 2 _ Nationwide _ March 2021.xlsx",
  "Firefish _ Jif Peanut Butter _ Nationwide _ Jan 2021.xlsx",
  "Firefish _ Kona 2 _ Revelation.xlsx",
  "Firefish _ Kona Beer _ July 2022 _ Job #2150.xlsx",
  "Firefish _ Lallier Champagne _ March 2021.xlsx",
  "Firefish _ Light Beer _ InterVu _ July 2020.xlsx",
  "Firefish _ MUL ( Michelob Ultra Light) _ April 2021 _ Job #.xlsx",
  "Firefish _ Maker_s Mark Star Hill _ Nov 2021 _ Job #2071.xlsx",
  "Firefish _ Makers Mark _ NY LA CHI _ July 2021.xlsx",
  "Firefish _ Michelob Ultra - Pure Gold _ September 2020 _ NY, CHI, LA _ Job #.xlsx",
  "Firefish _ Michelob Ultra _ California, Texas, Etc. _ December 2019 _ Job.xlsx",
  "Firefish _ Michelob Ultra _ InterVu _ March 2020 _ Job 1888.xlsx",
  "Firefish _ Michelob Ultra _ July 2022 _ Job #2157.xlsx",
  "Firefish _ Michelob Ultra _ NY _ June 2023 _ Job #2240.xlsx",
  "Firefish _ Natural Light Seltzer _ NY LA CHI _ Aug 2020.xlsx",
  "Firefish _ Olivia _ Online Depths _ Nationwide _ Oct 2023 _ Job #2257.xlsx",
  "Firefish _ Patrón _ ONLINE _ NY, CA, FL, TX _ July 2023 _ Job #2247.xlsx",
  "Firefish _ Piano Tequila II _ Online _ CA, NY, FL, TX _ Oct 2023 _ Job #2272.xlsx",
  "Firefish _ Project Bryan Cointreau _ New York _ June 2021 _ Job #.xlsx",
  "Firefish _ Project Dairy _ East_West Coasts _ April 2021.xlsx",
  "Firefish _ RL Bedding _ October 2022 _ Job #2186.xlsx",
  "Firefish _ RL Cliff _ NY _ LA _ April 2023 _ Job #2221.xlsx",
  "Firefish _ Samsung _ Nationwide _ May 2021.xlsx",
  "Firefish _ Stella #2 _ NY, LA _ November 2019 _ Job 1855.xlsx",
  "Firefish _ Stella #3 _ NYC _ LA _ November 2019 _ Job #.xlsx",
  "Firefish _ Stella #4 _ LA (online) _ NY _ March 2020 _ Job 1879.xlsx",
  "Firefish _ Stella #5 _ LA (Online) _ NY _ March 2020 _ Job.xlsx",
  "Firefish _ Stella Artois _ LA, CHI, NYC, MIAMI _ April 2019 _ Job 1778.xlsx",
  "Firefish _ Stella Non Alcoholic Beers _ March 2021 _ Job #1991.xlsx",
  "Firefish _ Stella Solstice II _ August 2021 _ New York_ LA_Miami _  Job #.xlsx",
  "Firefish _ Stella Solstice _ NY LA MIA _ Aug 2020.xlsx",
  "Firefish _ Stella Urgent _ NY _ LA _ Sept 2020 _ Job #.xlsx",
  "Firefish _ Stella _ NY _ November 2019 _ Job 1852.xlsx",
  "Firefish _ Stella _ NY_MIA_LA _ July 2021.xlsx",
  "Firefish _ Tommy Hilfiger _ NY, CHI _ February 2020 _ Job 1868.xlsx",
  "Firefish _ Travis Scott CACTI _ Nationwide _ April 2021 _ Job #2004.xlsx",
  "Firefish _ W Hotels - Marriott _ NY _ September 2019 _ Job 1826.xlsx",
  "Firefish _ WTC _ NY _ January 2019 _ Job 1750.xlsx",
  "Firefish _ Walmart _ Chicago _ August 2020.xlsx",
  "Firefish _ Whiskey Sustainability _ NATIONWIDE _ August 2022 _ Job #2164.xlsx",
  "Flamingo _ Coinbase Prime _ Feb _ Job #2097.xlsx",
  "Flamingo _ Coinbase Wallet _ Dec 2021.xlsx",
  "Flamingo _ Coinbase _ September 2021 _ Job #2055.xlsx",
  "Flamingo _ Destiny II _ LA NY CHI _ August 2021 _ Job #.xlsx",
  "Flamingo _ Facebook (Whatsapp) _ CHI _ March 2020 _ Job.xlsx",
  "Flamingo _ Facebook PIP _ CE _ CHI _ Jan 2020 _ Job 1864.xlsx",
  "Flamingo _ Facebook _ NY, LA _ January 2019 _ Job 1747.xlsx",
  "Flamingo _ Greenies _ March 2021 _ Job #1986.xlsx",
  "Flamingo _ HBO _ CHI, LA, NY _ March 2020 _ Job 1887.xlsx",
  "Flamingo _ HBO _ NY CHI LA DAL _ Feb 2021 _ Job # 1979.xlsx",
  "Flamingo _ Instagram #3 _ May 2020 _ LA _ CHI _ Job #1897.xlsx",
  "Flamingo _ Instagram _ NY, CHI _ April 2020 _ Job 1890.xlsx",
  "Flamingo _ Lululemon Virtual _ November 2020 _ Job #.xlsx",
  "Flamingo _ Lululemon _ June 2020 _ Job 1901.xlsx",
  "Flamingo _ McDonald_s _ NY_NJ, FL, BOS _ Sept-Oct 21 _ Job #2059.xlsx",
  "Flamingo _ Miro _ Jan-Feb _ Job #.xlsx",
  "Flamingo _ Newell - The future of the Workplace _ Nov 2021 _ Job #.xlsx",
  "Flamingo _ Newell Education _ Nationwide _ Oct 2021 _ Job #2065.xlsx",
  "Flamingo _ Project Aramis _ NY _ June 2019 _ Job.xlsx",
  "Flamingo _ Samsung Galaxy _ Chicago 2020 _ Job 1938.xlsx",
  "Flamingo _ Samsung Switcher _ CHI _ Aug 2020.xlsx",
  "Flamingo _ Shared Space _ BOS NY SF SJ _ Jan 2021.xlsx",
  "Flamingo _ Temptations T Cat _ March 2021 _ Job #1989.xlsx",
  "Flamingo _ The Economist _ NY _ Webex _ Discuss.io _ April 2020 _ Job #1893.xlsx",
  "Flamingo _ TikTok Culture _ LA NY HOU _ Jan 2021.xlsx",
  "Flamingo _ Tiktok _ June 2021.xlsx",
  "Fox Deportes _ Liga MX _ August 2021 _ Job #2044.xlsx",
  "Fox Sports _ Studio Shows _ LA _ June 2019 _ Job.xlsx",
  "Fox Sports _ Studio Shows _ LA _ March 2019 _ Job 1772.xlsx",
  "Fuse Media Sex Sells _ CHI HOU ATL MIA _ JAN 2022.xlsx",
  "Fuse _ WHYQ _ Big Sex Talk _ Online Nationwide _ Oct 2023 _ Job #1227.xlsx",
  "Fuse _ WHYQ _ Like a Girl _ Chicago _ May 2023.xlsx",
  "Fuse _ WHYQ _ Quince Dreams _ In Person CHI _ Oct 2023 _ Job #1228.xlsx",
  "GALKAL _ Project Guevara (stage 2) _ NY _ June 2019 _ Job 1804.xlsx",
  "GALKAL _ Project Guevara _ NYC _ April 2019 _ Job #1779.xlsx",
  "GRO FieldWork _ Bord Bia _ NY, CHI _ June 2019 _ Job 1798_.xlsx",
  "GRO Fieldwork _ Drumshanbo Gunpowder Gin _ Feb 21 _ Job #.xlsx",
  "Glanbia _ Fitness Lifestyles _ In person _ NY _ May 2023 _ Job #2229.xlsx",
  "Glanbia _ Los Angeles _ In Person (Ritz) _ March 2023 _ Job #2214.xlsx",
  "Goodwin Simon _ SMC _ LA _ April 2019 _ Job #.xlsx",
  "Hall _ Partners _ LVMH _ NY _ IN-PERSON _ August 2022 _ Job #2165.xlsx",
  "Happy Thinking People _ Heat Brush _ CHI _ July 2020 __.xlsx",
  "Happy Thinking People _ Project Champagne _ June 2020.xlsx",
  "Hawk Partners _ Brand Advertisers _ CHI _ NY _ December 2019 _ Job #1856.xlsx",
  "Heart + Mind Strategies _ Philanthropy _ NY _ January 2020 _ Job 1860.xlsx",
  "Heart and Mind _ $5MM+ _ LA _ February 2019 _ Job 1768.xlsx",
  "Human Innovation _ AI Resorts _ NY _ January 2019 _ Job_.xlsx",
  "Hypothesis _ Capital One _ July 2023 _ Job #2250.xlsx",
  "Hypothesis _ Hulu Disney Plus Co-Creation _ In-Person _ LA _ Sept 2023 _ Job #2267.xlsx",
  "Hypothesis _ Mastercard Value Prop Innovation _ Online Nationwide_ November 2023 _ Job #2289.xlsx",
  "IMPORT - Firefish _ Jagermeister _ NY, LA, CHI _ December 2017 _ Job 1640.xlsx",
  "IMPORT - Incite _ Hudson (Bourbon) _ NYC, CHI _ December, 2017 _ Job 1644.xlsx",
  "IMPORT Insights Strategy Group _ Outlaw King (Netflix) _ LA _ February 2018 _ Job 1654.xlsx",
  "Ifop _ Diamonds _ Dec 2021 _ NY LA CHI.xlsx",
  "Ifop _ LV Rouge _ NY In-Person _ April 2023 Job #2224.xlsx",
  "Ifop _ Luxury Watches _ LA _ NY _ July 2023 _ Job #2249.xlsx",
  "Incite _ Batch & Bottle _ Nationwide _ January 2023 _ Job #2192.xlsx",
  "Incite _ Chase SMB _ CHI _ December 2019 _ Job 1858.xlsx",
  "Incite _ Forevermark - Jewelry Concept _ CHI _ October 2019 _ Job #1836.xlsx",
  "Incite _ Kohler _ CHI _ LA _ October 2019 _ Job # 1838.xlsx",
  "Incite _ Patreon Prospect Creator _ May 2021 _ Job #.xlsx",
  "Incite _ Shiseido CPB KRC _ NY _ ONLINE _ October 2022 _ Job #2178.xlsx",
  "Incite _ Shiseido Facial UV _ In-Person _ NY _ LA _ Nov 2023 _ Job #2275.xlsx",
  "Incite _ Shiseido GSC Concepts _ LA _ Oct 2022 _ Job #2174.xlsx",
  "Incite _ Shiseido Refill _ NY, LA, CHI, SF _ Feb 21 _ Job #1976.xlsx",
  "Incite _ Shiseido Suncare Research _ December 2020 _ Job #1951.xlsx",
  "Incite _ Shiseido Sunscreen _ NY (and beyond) _ October 2019 _ Job 1839.xlsx",
  "Incite _ UNiDAYS _ NYC _ March 2019 _ Job 1769.xlsx",
  "Incite _ Virgin Red - Flying Club Members _ Nationwide _ March 2022 _ Job #2113.xlsx",
  "Informer Research _ Social Media _ January 2019 _ LA, NY _ Job #.xlsx",
  "Insight _ Netflix Kids workshop _ Los Angeles _ January 2020 _ Job 1861.xlsx",
  "International-Insights _ Prestige Hair Tools _ LA _ January 2020 _ Job 1868.xlsx",
  "Ipsos _ Facebook _ LA _ CHI _ July 2019 _ Job #1186.xlsx",
  "Ipsos _ GE Appliances _ Nationwide _ Dec 2021.xlsx",
  "Ipsos _ Shiseido 23AW _ Online _ NY _ Nov 2023 _ Job #2293.xlsx",
  "Ipsos _ Shiseido CPB _ Online _ NY _ LA _ Nov 2023 _ Job #2278.xlsx",
  "Ipsos _ Tiffany _ Co. Jewelry _ NY, CHI _ January 2020 _ Job 1865.xlsx",
  "Johanna Funnell (Estee Lauder) _ Nutrition Experts _ NY _ February 2020 _ Job 1870.xlsx",
  "Johanna Funnell Consulting _ Beauty Influencers _ NYC _ October 2019 _ Job 1843.xlsx",
  "Johanna Funnell Consulting _ La Mer _ OHL NY IN-PERSON _ July 2021.xlsx",
  "Johanna Funnell _ La Mer Concepts _ September 2020 _ Job #1927.xlsx",
  "Johanna Funnell _ La Mer _  LA, NY, MIA _ May 2020 _ Job#.xlsx",
  "June Marketing _ Luxury Fashion _ NY (MAYBE LA) _ April 2021.xlsx",
  "June Marketing _ Pearl (Van Cleef _ Arpels) _ NY _ January 2019 _ Job #1751_.xlsx",
  "June Marketing _ Remy Martin _ NY, LA, MIA _ March 2023 _ Job #2217.xlsx",
  "June Marketing _ Watches _ Jewelry _ LA _ June 2019 _ Job.xlsx",
  "KNow Research _ Ebay Marketplace _ CHI _ August 2021.xlsx",
  "Kantar _ CBD _ In Person _ LA _ March 2023 _ Job #2211.xlsx",
  "Kelton _ ABI Bartenders _ June 2021 _ Job #.xlsx",
  "Kelton _ Canon IVY _ April 22 _ Job #2124.xlsx",
  "Kelton _ Canon Innovation _ Nationwide _ December 2020.xlsx",
  "Kelton _ DAZN _ MLB _ LA, CHI _ February 2019 _ Job 1761.xlsx",
  "Kelton _ Google Dumbledore (Mommy Bloggers) _ LA _ CHI _ October 2019 _ Job # 1835.xlsx",
  "Kelton _ Google Electronics Study _ Chicago _ August 2019 _ Job #.xlsx",
  "Kelton _ Harry Potter _ Project Elder _ LA _ January 2020 _ Job 1866.xlsx",
  "Kelton _ Invitae _ Consumer Motivations _ Los Angeles _ July 2019 _ Job #1811.xlsx",
  "Kelton _ Mailchimp Automation _ NATIONWIDE _ April 2020 _ Job #1886.xlsx",
  "Kelton _ Mailchimp Content Creation _ June 2021 _ Job #.xlsx",
  "Kelton _ Mailchimp Smart Content _ June 2020 _ Job 1902.xlsx",
  "Kelton _ Mailchimp _ NY, CHI _ March 2020 _ Job #1881.xlsx",
  "Kelton _ Meta Horizons _ NATIONWIDE _ June 2022 _ Job #2142.xlsx",
  "Kelton _ Meta Mental Models _ Online _ May 2022 _ Job #2132.xlsx",
  "Kelton _ Nordstrom _ Chicago _ October 2019 _ Job #1837.xlsx",
  "Kelton _ Target Loyalty _ LA _ IN PERSON _ June 2022 _ Job #.xlsx",
  "Kelton _ Target _ CHI _ March 2019 _ Job 1771.xlsx",
  "Kelton _ Target _ New York _ April _22 _ Job #2119.xlsx",
  "Kelton _ Wistia _ May 2021.xlsx",
  "Labrador Agency _ FOX Sports _ In-Person _ NY _ Nov 2023 _ Job #2276.xlsx",
  "Labrador _ RuPaul Drag Race _ NY _ February 2020 _ Job 1872.xlsx",
  "Linkage Research _ Spin Mop Bucket Test _ CHI _ August 2021.xlsx",
  "METIS _ Aigle Outdoor Fashion, NY_CHI_LA _ May 2021 _ Job #_.xlsx",
  "METIS _ Alpine _ In Person _ New York & Los Angeles _ February 2023 _ Job #2011.xlsx",
  "METIS _ Alpine _ In Person _ New York _ Los Angeles _ February 2023 _ Job #2011.xlsx",
  "METIS _ Chanel Whitening _ NY _ ONLINE _ Aug 2022 _ Job #2161.xlsx",
  "METIS _ Cognac _ NY CHI LA ATL _ Sept 2020.xlsx",
  "METIS _ Future of Family Cars _ Nationwide _ April 2023 _ Job #2218.xlsx",
  "METIS _ Lacoste _ NY LA MIA ATL HOU _ August 2021.xlsx",
  "METIS _ Lacoste _ Online _ NY, LA, MIA _ Dec 2023 _ Job #2297.xlsx",
  "METIS _ Puig Fragrance _ Online _ Nationwide _ Sept 2023 _ Job #2266.xlsx",
  "METIS _ Saint Remy _ November 2022 _ NYC, MIAMI, LA _ Job #2186.xlsx",
  "MINE MR _ Honeybook (Small Business Owners) _ LA _ June 2019 _ Job.xlsx",
  "MSG _ Knicks _ NY _ July 2019 _ Job #.xlsx",
  "M_TIS _ Cognac _ CHI _ LA _ November 2019 _ Job #1849.xlsx",
  "M_TIS _ Fragrances _ NY _ November 2019 _ Job #1851.xlsx",
  "Magnetic Collective _ Chromebook _ In-Person _ NY, CHI _ Nov 2023 _ Job #2291.xlsx",
  "Magnetic Collective _ Google AI Feature Messaging _ In-Person _ CHI _ LA _ Oct 2023 _ Job #2274.xlsx",
  "Magnetic Collective _ Google P9 Value Prop _ In-Person LA _ AUGUST 2023 _ Job #2257.xlsx",
  "Magnetic Collective _ Google Pixel _ In-Person CHI _ July 2023 _ Job#2252.xlsx",
  "Magnetic Collective _ Google Smartphones _ In-Person NYC _ August 2023 _ Job #2256.xlsx",
  "Magnetic Collective _ IG Teen _ In-Person _ NY _ Nov 2023 _ Job #2284.xlsx",
  "Magnetic Collective _ Maybelline _ In-Person NY _ LA _ Sept 2023 _ Job #2263.xlsx",
  "Magnetic Collective _ Military Home Buyers _ IN-PERSON _ July 2022 _ Job #2147.xlsx",
  "Magnetic Collective _ Recent Switchers _ Super Switchables _ August 2023 _ Job #2258.xlsx",
  "Magnetic Collective _ Smartphones _ NY _ In-Person _ January 2024 _ Job #2309.xlsx",
  "Magnetic Collective _ Smartphones _ NY, CHI _ August 2022 _ Job #2162_.xlsx",
  "Match.com _ Tinder _ LA _ May 2019 _ Job YQ1178.xlsx",
  "Material _ RJR Strategic City Qual Vape _ NY LA Dallas Miami _ May 2023 _ Job #2228.xlsx",
  "Material+ _ Meta Developers _ Nationwide _ April 2023 _ Job #2222.xlsx",
  "McCann _ Ulta Beauty Expert Panel _ NY _ November 2019 _ Job YQ1191.xlsx",
  "Metis _ Chanel _ NY _ IN PERSON _ October 2022 _ Job #2183.xlsx",
  "Metis _ St Remy _ LA Miami Atlanta _ May 2023 _ Job #2231.xlsx",
  "Metis _ Ubisoft Brand Promise _ NYC _ May 2021.xlsx",
  "Metis _ Ubisoft Stealth _ ONLINE _ NATIONWIDE _ May 2022 _ Job # 2129.xlsx",
  "Monigle _ Project Lite (Absolut) _ LA _ August 2019 _ Job #1820.xlsx",
  "National Research Group _ Netflix The Willoughbys _ LA _ June 2019 _ Job.xlsx",
  "Netflix _ Lockdown _ In-Person _ NY _ Nov 2023 _ Job #1229.xlsx",
  "Omnivore _ Tres Gen Tequila _ March 2022.xlsx",
  "PSMR Services _ Figma _ April 22 _ Job #2118.xlsx",
  "PSMR Services _ Liberty Mutual _ Jan 2022_.xlsx",
  "P_G _ Dry Shampoo _ New York _ October, 2019 _ Job #.xlsx",
  "Pepsi Co. _ Detroit _ July 2019 _ Job_.xlsx",
  "Plural Thinking _ Airport Retail Project _ March 2021 _ Job #1992.xlsx",
  "Plural Thinking _ BF Jack Daniels _ Feb 22 _ Job #2107.xlsx",
  "Plural Thinking _ Brockmans Gin _ NY _ LA _ November 2020 _ Job #1946.xlsx",
  "Plural Thinking _ Glendronach _ In-Person NY & LA _ January 2023 _ Job #2203.xlsx",
  "Plural Thinking _ Glendronach _ NY LA _ Jan 2021.xlsx",
  "Plural Thinking _ Glendronach _ NY, LA _ April 2019 _ Job #1775.xlsx",
  "Plural Thinking _ Glendronach _ November 2021 _ Job #2078.xlsx",
  "Plural Thinking _ Jack Daniel’s 1938 _ CHI, NY, ATL, DAL_HOU _ Oct-Nov 2021 _ Job #2052_.xlsx",
  "Prophet _ AT_T _ Chicago _ April 2019 _ Job#1783.xlsx",
  "Prophet _ AT_T _ LA _ May 2019 _ Job #1793.xlsx",
  "RE-DO_ Amex GANC _ September 2019 (Originally July 2019).xlsx",
  "Reliable Services _ Clase Azul Tequila _ ONLINE _ NATIONWIDE _ July 2022 _ Job #2151.xlsx",
  "Reverb Research _ JBL _ Online _ National _ February 2023 _ Job #.xlsx",
  "Reverb Research _ Jameson Black Barrel Deep _ NY, LA, CHI, ATL, HOU _ Sept 2021 _ Job #.xlsx",
  "Reverb Research _ Jameson Coffee _ NY, CHI _ May 2019 _ Job 1786.xlsx",
  "Reverb Research _ Jameson _ NY _ LA _ November 2020 _ Job#1943.xlsx",
  "Reverb Research _ Jameson _ NY, CHI, LA _ January 2020 _ Job 1841.xlsx",
  "Reverb Research _ Jameson _ NYC, CHI, LA, FL (Not Miami) _ April 2023 _ Job #.xlsx",
  "Reverb Research _ Jameson _ New York _ August 2019 _ Job#1824.xlsx",
  "Reverb Research _ Powers _ May 22 _ Job #2126.xlsx",
  "Reverb _ Jameson Big Idea Phase 2 _ NY_CHI_LA_ATL_HOU_TAM _ May 2021 _ Job #2009.xlsx",
  "Reverb _ Jameson Intrinsics Phase 2 _ National.xlsx",
  "Reverb _ Jameson Online Interviews _ NY, CHI, LA _ February 2020 _ Job 1877.xlsx",
  "Reverb _ Jameson _ Big Idea Phase 1 _ March 2021.xlsx",
  "Reverb _ Jameson _ NY, CHI, LA _ April 2020 _ Job 1894.xlsx",
  "Reverb _ Optimum Nutrition _ In Person NY _ CHI _ Online LA _ MIA _ Oct 2023 _ Job #2270.xlsx",
  "Roundpeg Consulting _ Corona Sunbrew _ In-Person CHI _ NY _ Sept 2023 _ Job #2265.xlsx",
  "Roundpeg Consulting _ Cuatro Tequila _ In Person _ Online _ CHI, LA, NY, MIA, TX _ Nov 2023 _ Job #2283.xlsx",
  "Roundpeg _ Prisoner Whiskey _ CHI In-Person_Nationwide(CA_TX) Online _  April 2023  _ Job #2019.xlsx",
  "Rupture Studio _ WHYQ _ SoundCloud _ Dec 2021 _ Job #.xlsx",
  "Rupture Studios _ Spotify _ Baltimore, Atlanta, Houston _ October 2020 _ Job 1937.xlsx",
  "SK Consulting Services LLC _ Snacks _ ONLINE _ IN PERSON _ New York _ June 22 _ Job #2122.xlsx",
  "Silvia Fassi _ Creatives w_ Allergies _ NY _ November 2019 _ Job 1844.xlsx",
  "Silvia Fassi _ Fashion _ LA, NY _ July 2022 _ Job #2148.xlsx",
  "Silvia Fassi _ Pain _ NY _ August 2019 _ Job #1823.xlsx",
  "Silvia Fassi _ Project Tommy _ New York _ September 2021 _ Job #2054.xlsx",
  "Silvia Fassi _ Small Dogs _ May 2019 _ CHI _ Job 1787.xlsx",
  "Sorgem Advance _ Chanel Refillable Groups _  April 22 _ Job #2101.xlsx",
  "Sorgem Advance _ Michelin II _ Online _ Nationwide _ Dec 2023 _ Job #2298.xlsx",
  "Sorgem _ Chanel Allure _ ONLINE _ NATIONWIDE _ November 2022 _ Job #2196.xlsx",
  "Sorgem _ Michelin Guide _ Online _ Nationwide _ Job #2220.xlsx",
  "Sorgem _ Michelin Tire _ LA NY CHI _ August 2023 _ Job #2254.xlsx",
  "Sorgem _ Stellantis _ Nationwide _ April 2023 _ Job #2225.xlsx",
  "Source Fieldwork _ DUREX 3 _ March 2021 _ Job #.xlsx",
  "Source Fieldwork _ Danone Activia _ ONLINE _ NJ, LA _ May 2022 _ Job# 2138.xlsx",
  "Source Fieldwork _ Durex 2 _ NY _ LA _ Feb 2021 _ Job #.xlsx",
  "Source Fieldwork _ Durex _ NY LA _ Feb 2021.xlsx",
  "Source Fieldwork _ Tequila _ NY LA _ June 2021 _ Job #2020.xlsx",
  "Sweetgreen _ LA _ June 2019_.xlsx",
  "T3 Skyfall _ In-Salon Prototype Testing _ LA _ August 2021.xlsx",
  "T3 _ Skyfall Core Design _ LA _ July 2020.xlsx",
  "TAG Research _ Kahlua Especial _ Online _ CA, FL, TX _ Nov 2023 _ Job #2287.xlsx",
  "TAG _ Absolut RTD _ Online _ LA, NY, CHI, TX, AZ _ Oct 2023 _ Job #2271.xlsx",
  "TAG _ Kahlua Portfolio _ Online _ NY, CA, TX, FL, IL _ Nov 2023 _ Job #2280.xlsx",
  "TAG _ Malibu Innovation _ Online _  NY, CA, TX, FL, IL _ Oct 2023 _ Job #2273.xlsx",
  "Tag Research _ Absolut RTD _ 4 NY, 4 LA, 4, FL, 4 IL and 2 of each from TX, GA, OH, AZ _ June 2021 _ Job #.xlsx",
  "Tag Research _ Malibu _ April 22 _ Job #2117.xlsx",
  "Tag Research _ Malibu _ Chicago _ March 2019 _ Job 1770.xlsx",
  "Tag Research _ Malibu _ In Person _ Chicago In Person _ Jan 2023 _ Job #2204.xlsx",
  "Tag Research _ Malibu _ Sept 2022 _ Job #2169.xlsx",
  "Tag _ Jameson RTD _ CHI, LA, FL, TX _ July 2023 _ Job #2251.xlsx",
  "The Good Side _ Instagram Brand Positioning _ LA, CHI _ ONLINE _ IN PERSON _ Nov 22 _ Job #2193.xlsx",
  "The Magnetic Collective _ In Person LA _ Google Pixel _ April 2023 _ Job #2223.xlsx",
  "The Magnetic Collective _ Makeup, Fragrance _ Fashion _ IN PERSON _ NYC, LA _ November 2022 _ Job #.xlsx",
  "The Mix Global _ Johnnie Walker Black _ In Person _ NY _  March 2023 _ Job #2215.xlsx",
  "The Mix _ Johnnie Walker Black _ CHI NY _ June 2023 _ Job #2246.xlsx",
  "Thea Research _ Cartier Handbags _ In-Person NYC _ August 2023 _ Job #2262.xlsx",
  "Thea Research _ Thayers _ In-Person _ NY _ Nov 2023 _ Job #2282.xlsx",
  "TideWatch _ Citi Small Business _ NYC, LA, SF, CHI, Dallas _ Nov 2021 _ Job #2072 (Online) #2070 (In Person).xlsx",
  "Tidewatch _ New York Life _ November 2021 _  Job #2082.xlsx",
  "Triggers _ Chivas Hustle Culture.xlsx",
  "Trufflefield _ Compton _ Dean _ De Beers _ CHI_NJ_HOU_ATL_BOS _ May 2021 _ Job #2011.xlsx",
  "Trufflefield _ De Beers _ In Person NY & LA _ March 2023 _ Job #2209.xlsx",
  "Trufflefield _ De Beers _ In Person NY _ LA _ March 2023 _ Job #2209.xlsx",
  "Trufflefield _ Forevermark _ CHI _ May 2019 _ Job 1789.xlsx",
  "Trufflefield _ Ziba Fragrance _ In-Person _ New York _ Nov 2023 _ Job #2290.xlsx",
  "Verdes NYC _ Johnnie Walker _ Nov 2021 _ Job #.xlsx",
  "Vital Findings _ HOKA One _ Nationwide _ October 2020 _ Job 1933.xlsx",
  "Vital Findings _ UGGs _ National _ April 2021.xlsx",
  "WHY-Q _ AMEX - Membership Rewards + Get a New Card  _ NY, DALLAS _ July 2019 _ YQ Job #1184.xlsx",
  "WHY-Q _ Adidas _ NY, PHIL, ATL, CHI, LA _ January 2019 _ Job YQ 1170.xlsx",
  "WHY-Q _ FUSE TV - Upcycle Nation _ Chicago In Person _ February 2023 _ Job #.xlsx",
  "WHY-Q _ Fuse WNTTAA _ Click to Join _ June 2022 _ LA IN-PERSON.xlsx",
  "WHY-Q _ FuseTV _ MADE FROM SCRATCH _ IN-PERSON _ LA _ July 2022 _ Job #1212.xlsx",
  "WHY-Q _ FuseTV _ UPTICK _ ONLINE _ NATIONWIDE _ July 2022 _ Job #1211.xlsx",
  "WHY-Q _ Humans of Gaming _ NY, London, Paris _ May 2019 _ YQ Job#1179.xlsx",
  "WHY-Q _ Lexus Usability #2 _ DALLAS _ July 2019 _ YQ Job # 1183.xlsx",
  "WHY-Q _ MEKANISM _ Cuervo Gen Z _ LA, CHI, DALLAS _ IN PERSON _ November 2022 _ Job #1215.xlsx",
  "WHY-Q _ NutriBullet _ CHI _ July 2019 _ Job #1181.xlsx",
  "WHY-Q _ Perfect Bar _ Online _ Nationwide _ April 2023 _ Job #1222.xlsx",
  "WHY-Q _ Rupture _ Homebuyers _ In Person _ ATL _ Feb 2023 _ Job #2207.xlsx",
  "WHY-Q _ Rupture _ Online _ Betting _ New York, Chicago _ January 2023 _ Job #2206.xlsx",
  "WHY-Q _ Samsung 3D Animators Social Media Influencers _ NY, LA _ January 2019 _ Job_.xlsx",
  "WHY-Q _ Sorgem _ Chanel J12 _ NY LA MIA _ June 2023 _ Job #1226.xlsx",
  "WHY-Q _ Supercell Brawl Stars _ CHI _ June 2019 _ Job #YQ 1180.xlsx",
  "WHY-Q _ Zound Portable Speakers _ LA _ Ethnos _ August 2022 _ Job #1210.xlsx",
  "WHYQ Apple Retail Broadcast Research _ NY UK CHINA _ Feb 2021.xlsx",
  "WHYQ _ FUSE _ Thought Leadership _ Nationwide _ Oct 2022.xlsx",
  "WHYQ _ Netflix _ Channel Optimization _ November 2022 _ Job #1214.xlsx",
  "White Cliff Co _ Cheetos _ In-Person LA _ AUGUST 2023 _ Job #2260.xlsx",
  "White Cliff Co _ Doritos _ LA _ June 2023 _ Job #2242.xlsx",
  "Why-Q_ Adidas Basketball _ Atlanta, Chicago, Houston _ April 2019.xlsx",
  "Wisk _ Designing the future of flight _ LA _ Aug 2020 _ Job #.xlsx",
  "Wyckoff Partners _ Puffco Fox _ In-Person _ LA _ Nov 2023 _ Job #2279.xlsx",
  "Wyckoff _ Puffco Cannabis _ IN-PERSON _ LA _ May 2023 _ Job #2236.xlsx",
  "YARD _ Female Hygiene _ LA, CHI, NY _ September 2019 _ Job #1828.xlsx",
  "b12 Strategies _ Sophisticates (Tiffany _ Co.) _ CHI _ NY _ January 2019 _ Job_.xlsx",
  "hdspc _ TuneIn _ LA, CHI, NY, DALLAS, BOSTON _ February 2019 _ Job 1766.xlsx",
  "ifop _ Belvedere _ New York, Los Angeles, Miami _ March 2022 _ Job #2111.xlsx",
  "ifop _ LVMH Metaverse _ Feb 2022 _ Job #2106.xlsx",
  "ifop _ Luxury Fashion _ NY, LA _ June 2022 _ Job #2140.xlsx",
];

export const occupations = [
  "legal_consulting",
  "administrative_support",
  "technology_engineering",
  "real_estate_property",
  "marketing_pr",
  "writing",
  "parent",
  "entrepreneurship",
  "not_grouped",
  "education_training",
  "hospitality_and_culinary",
  "sales",
  "design_arts",
  "transportation_delivery",
  "finance_banking_business",
  "unemployed",
  "student",
  "healthcare_professionals",
  "teacher",
  "social_services",
  "personal_services",
  "retired",
  "healthcare_support",
  "military_public_service",
  "entertainment_arts",
  "management",
  "construction_trades",
  "parenting_caregiving",
];

export const markets = [
  "New York City",
  "Los Angeles",
  "Chicago",
  "Miami",
  "Dallas",
  "Atlanta",
  "London",
  "New Jersey",
  "Houston",
  "San Francisco",
  "Urban",
  "Philadelphia",
  "Boston",
  "Tampa",
  "Berlin",
  "Seoul",
  "Illinois",
  "Washington DC",
  "Seattle",
  "Texas",
  "Florida",
  "Suburban",
  "Denver",
  "Austin",
  "Toronto",
  "Georgia",
  "Brooklyn",
  "San Antonio",
  "Maryland",
  "Santa Monica",
];

export let ethnicities = ["Pacific Islander", "Caribbean", "Asian", "Indian", "Middle Eastern", "Native American", "African American", "Jewish", "Caucasian", "Mixed", "Hispanic"];

export const genders = [
  "they/them",
  "female",
  "trans masculine",
  "do not wish to disclose",
  "unknown",
  "trans (see notes)",
  "genderqueer (they/them)",
  "non-binary",
  "male",
  "trans femme",
  "i present mostly masc, identify as a boy and use they/them pronouns.",
  "trans/gender-nonconforming",
  "trans - female",
  "she/they",
];

export const martialStatus = ["In a relationship", "Married", "Divorced", "Single"];
